<p-confirmDialog key="confirmsecurity" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="security" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MenuGrid">
	<h4 class="MenuHeading">Account Settings</h4>

	<!--Used by User Admin-->
	<label for="OneAccountPerStaffMember">One account per staff member (Disable multiple accounts for the same person):</label>
	<input
		id="OneAccountPerStaffMember"
		value="OneAccountPerStaffMember"
		class="form-control"
		type="checkbox"
		[(ngModel)]="OneAccountPerStaffMember"
		[disabled]="IsLoading() == true"
	/>

	<label for="UsernameMustMatchEmail">Username must match email:</label>
	<input
		id="UsernameMustMatchEmail"
		value="UsernameMustMatchEmail"
		class="form-control"
		type="checkbox"
		[(ngModel)]="UsernameMustMatchEmail"
		[disabled]="IsLoading() == true"
	/>

	<label for="UsernameEmailMustHaveDomain">Username/Email must have domain (Ex. must have @k12.com):</label>
	<input
		id="UsernameEmailMustHaveDomain"
		value="UsernameEmailMustHaveDomain"
		class="form-control"
		type="checkbox"
		[(ngModel)]="UsernameEmailMustHaveDomain"
		[disabled]="IsLoading() == true"
	/>

	<label>Account lockout occurs after n-number of failed login attempts</label>
	<select class="form-control" name="PasswordReuseID" [(ngModel)]="LockoutAttemptsID" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstLockoutAttempts" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>

	<!--Lock Accounts Job-->
	<label>Lock accounts that haven't logged in for x Days (0 = Don't Lock anyone):</label>
	<input class="form-control" type="number" min="0" max="100" [(ngModel)]="LockAccountAfterDays" [disabled]="IsLoading() == true" />

	<label>Logout if inactive for x minutes (0 = Don't automatically logout):</label>
	<input class="form-control" type="number" min="0" [(ngModel)]="InactiveLogoutMinutes" [disabled]="IsLoading() == true" />

	<h4 class="MenuHeading">Password Settings</h4>

	<label>Password expiration occurs:</label>
	<select class="form-control" name="PasswordExpID" [(ngModel)]="PasswordExpID" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPasswordExp" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>

	<label>Password can not be reused after n-number of expires:</label>
	<select class="form-control" name="PasswordReuseID" [(ngModel)]="PasswordReuseID" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstPasswordReuse" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>

	<!--Used by User Admin-->
	<label>Password minimum length:</label>
	<input class="form-control" type="number" min="1" max="100" [(ngModel)]="MinLength" [disabled]="IsLoading() == true" />

	<!--Used by User Admin-->
	<label for="ContainNumbers">Password must contain numbers:</label>
	<input id="ContainNumbers" value="ContainNumbers" class="form-control" type="checkbox" [(ngModel)]="ContainNumbers" [disabled]="IsLoading() == true" />

	<!--Used by User Admin-->
	<label for="ContainSpecialChars">Password must contain special characters:</label>
	<input
		id="ContainSpecialChars"
		value="ContainSpecialChars"
		class="form-control"
		type="checkbox"
		[(ngModel)]="ContainSpecialChars"
		[disabled]="IsLoading() == true"
	/>

	<label for="ChangeAfterAdminReset">Password must be changed after admin alters user's password:</label>
	<input
		id="ChangeAfterAdminReset"
		value="ChangeAfterAdminReset"
		class="form-control"
		type="checkbox"
		[(ngModel)]="ChangeAfterAdminReset"
		[disabled]="IsLoading() == true"
	/>

	<label for="ConfirmPasswordWhenChanging">Make users enter their old password when trying to change their password:</label>
	<input
		id="ConfirmPasswordWhenChanging"
		value="ConfirmPasswordWhenChanging"
		class="form-control"
		type="checkbox"
		[(ngModel)]="ConfirmPasswordWhenChanging"
		[disabled]="IsLoading() == true"
	/>
</div>

<div class="MenuOutline TopMargin">
	<h4 class="MenuHeading">MFA Settings</h4>

	<div class="MainGrid2Col">
		<label for="MFAEnabled">Multi-Factor Authentication</label>
		<input id="MFAEnabled" value="MFAEnabled" class="form-control" type="checkbox" [(ngModel)]="MFAEnabled" [disabled]="IsLoading() == true" />
	</div>

	<div class="NoteDiv">
		<ul class="NotesList">
			<li>
				Turning on MFA from this screen means that everyone in the district will have to use an app like Google Authenticate and type in an extra code
				when they log in.
			</li>
			<li>
				Individual Schools can turn it on from School Settings/Preference Settings. This will force users that have access to the school to use MFA if
				the district has it turned off.
			</li>
			<li>Users can also turn on MFA from the My Settings popup (Gear Icon in top right near Logout).</li>
			<li>
				<span style="font-weight: bold">NOTE 1:</span> Schools can't opt-out of it if the District has it turned on, and users can't opt-out of it if
				the district or one of their schools has it turned on. I.e. Higher levels override lower levels (District > School > User) for turning the
				preference on.
			</li>
			<li>
				<span style="font-weight: bold">NOTE 2:</span> Turning a preference on or off at one level doesn't affect what is set at other levels (Ex. User
				A turns on MFA, then the District turns it on, then the District turns it off. User A will still have MFA on)
			</li>
		</ul>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" [disabled]="IsLoading() == true" (click)="onUpdate()">Update</button>
	<button class="btn btn-warning SmallMarginLeft" [disabled]="IsLoading() == true" (click)="onDisableMFA()">Turn Off MFA for All Schools</button>
	<button class="btn btn-primary SmallMarginLeft" [disabled]="IsLoading() == true" (click)="onUserExpirePasswordAll()">Expire All Passwords</button>
</div>
